var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { BaseWalletAdapter } from './adapter';
import { WalletError, WalletSendTransactionError } from './errors';
export class BaseSignerWalletAdapter extends BaseWalletAdapter {
    sendTransaction(transaction, connection, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                transaction.feePayer || (transaction.feePayer = this.publicKey || undefined);
                transaction.recentBlockhash || (transaction.recentBlockhash = (yield connection.getRecentBlockhash('max')).blockhash);
                const { signers } = options, sendOptions = __rest(options, ["signers"]);
                (signers === null || signers === void 0 ? void 0 : signers.length) && transaction.partialSign(...signers);
                transaction = yield this.signTransaction(transaction);
                const rawTransaction = transaction.serialize();
                return yield connection.sendRawTransaction(rawTransaction, sendOptions);
            }
            catch (error) {
                if (!(error instanceof WalletError)) {
                    error = new WalletSendTransactionError(error.message, error);
                }
                this.emit('error', error);
                throw error;
            }
        });
    }
}
//# sourceMappingURL=signer.js.map